import { render, staticRenderFns } from "./password.vue?vue&type=template&id=37db4382&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"
import style0 from "./password.vue?vue&type=style&index=0&id=37db4382&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37db4382",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37db4382')) {
      api.createRecord('37db4382', component.options)
    } else {
      api.reload('37db4382', component.options)
    }
    module.hot.accept("./password.vue?vue&type=template&id=37db4382&scoped=true", function () {
      api.rerender('37db4382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/profile/password/password.vue"
export default component.exports